<template>
   <div>
      <v-container>
         <v-dialog
            v-model="modal"
            persistent
            width="500px"
            height="400px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="280px">
               <v-row no-gutters>
                  <v-col cols="12">
                     <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                        <v-toolbar-title>
                           {{ modeCaption }}
                           <template v-if="$vuetify.breakpoint.mdAndUp">
                              Term Year
                           </template>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2">Cancel</v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2">OK</v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-form ref="termyearform" v-model="formvalid">
                  <v-card flat class="px-3">
                     <v-row no-gutters>
                        <v-col cols="3" md="4" class="px-4">
                           <v-text-field
                              label="Term"
                              v-model="edit_term"
                              required
                              :rules="[(v) => !!v || 'Term is required']"
                           ></v-text-field>
                        </v-col>
                        <v-col cols="3" md="4" class="px-4">
                           <v-text-field
                              label="Year"
                              v-model="edit_year"
                              required
                              :rules="[(v) => !!v || 'Year is required']"
                           ></v-text-field>
                        </v-col>
                     </v-row>
                     <v-row no-gutters>
                        <v-col cols="8" md="8" class="px-4">
                           <v-text-field
                              label="Term Year Text"
                              v-model="edit_termyeartext"
                              required
                              :rules="[(v) => !!v || 'Term Year Text is required']"
                           ></v-text-field>
                        </v-col>
                     </v-row>
                     <v-row no-gutters>
                        <v-col cols="3" md="4" class="px-4">
                           <datepicker-dialog
                              labelname="Start Date"
                              :indate.sync="edit_startdate"
                              @return-date="onStartDateChange"
                           >
                           </datepicker-dialog>
                        </v-col>
                        <v-col cols="3" md="4" class="px-4">
                           <datepicker-dialog
                              labelname="End Date"
                              :indate.sync="edit_enddate"
                              @return-date="onEndDateChange"
                           >
                           </datepicker-dialog>
                        </v-col>
                     </v-row>
                  </v-card>
               </v-form>
            </v-sheet>
         </v-dialog>
      </v-container>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import DatepickerDialog from "./DatepickerDialog.vue";

   export default {
      components: {
         ConfirmDlg,
         DatepickerDialog,
      },

      data() {
         return {
            modal: false,
            formvalid: true,
            termid: "",
            edit_term: "",
            edit_year: "",
            edit_termyeartext: "",
            edit_startdate: "",
            edit_enddate: "",
            formmode: "",
            modeCaption: "",
         };
      },
      methods: {
         todayDate() {
            return this.$globalstore.currentDateISOString().substr(0, 10);
         },

         open() {
            this.formmode = "add";
            this.modeCaption = "Add";

            this.edit_term = "";
            this.edit_year = "";
            this.edit_termyeartext = "";
            this.edit_startdate = this.todayDate();
            this.edit_enddate = this.todayDate();
            this.formvalid = true;

            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         edit(termdata) {
            this.formmode = "edit";
            this.modeCaption = "Edit";

            this.termid = termdata.id;
            this.edit_term = termdata.term;
            this.edit_year = termdata.year;
            this.edit_termyeartext = termdata.termyeartext;
            this.edit_startdate = termdata.term_start;
            this.edit_enddate = termdata.term_end;
            this.formvalid = true;
            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         onStartDateChange(date) {
            this.edit_startdate = date;
         },

         onEndDateChange(date) {
            this.edit_enddate = date;
         },

         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         OkBtnClick() {
            if (this.$refs.termyearform.validate()) {
               if (this.edit_startdate == this.edit_enddate) {
                  this.$refs.confirm
                     .open("Error", "End date must be greater than start date.", {
                        color: "red",
                        noconfirm: true,
                     })
                     .then((reply) => {
                        return;
                     });
               }

               let payload = {
                  termdata: {
                     id: this.termid,
                     term: this.edit_term,
                     year: this.edit_year,
                     termyeartext: this.edit_termyeartext,
                     term_start: this.edit_startdate,
                     term_end: this.edit_enddate,
                  },
                  mode: this.formmode,
               };
               this.resolve(true);
               this.modal = false;
               this.$emit("input", payload);
            } else {
               this.$refs.confirm
                  .open("Error", "Please complete the form.", {
                     color: "red",
                     noconfirm: true,
                  })
                  .then((reply) => {
                     return;
                  });
            }
         },
      },
   };
</script>
